const lottie = require('lottie-web');

module.exports = (data, el, loop = false) => {
    const params = {
        container: el,
        renderer: 'svg',
        loop: loop,
        autoplay: false,
        animationData: data
    };

    return lottie.loadAnimation(params);
};
